// extracted by mini-css-extract-plugin
export var closeButton = "_k8-1";
export var closeX = "_k8-3";
export var container = "_k8-0";
export var image = "_k8-2";